import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

window.addEventListener('DOMContentLoaded', () => {
	gsap.registerPlugin(ScrollTrigger)

	const img = gsap
		.timeline({
			scrollTrigger: {
				trigger: '.expand-section',
				scrub: true,
				pin: true,
				start: 'top',
				end: 'bottom',
			},
		})
		.from('.expand-section #logo', {
			scale: 0.2,
			transformOrigin: 'center center',
		})
		.to('.expand-section #logo', {
			scale: 15,
			transformOrigin: 'center center',
		})

		.to(
			'.expand-section .content-before-expand',
			{
				opacity: 0,
				y: innerHeight * 0.25,
			},
			0
		)

		.from('.expand-section .content-after-expand', {
			opacity: 0,
		})
		.to('.expand-section .content-after-expand', {
			opacity: 1,
		})

	// function scrollTrigger(selector, options = {}) {
	// 	let els = document.querySelectorAll(selector)
	// 	if (selector) {
	// 		els = Array.from(els)
	// 		els.forEach(el => {
	// 			addObserver(el, options)
	// 		})
	// 	}
	// }

	// function addObserver(el, options) {
	// 	if (!('IntersectionObserver' in window)) {
	// 		if (options.cb) {
	// 			options.cb(el)
	// 		} else {
	// 			entry.target.classList.add('active')
	// 		}
	// 		return
	// 	}
	// 	let observer = new IntersectionObserver((entries, observer) => {
	// 		//this takes a callback function which receives two arguments: the elemts list and the observer instance
	// 		entries.forEach(entry => {
	// 			if (entry.isIntersecting) {
	// 				if (options.cb) {
	// 					options.cb(el)
	// 				} else {
	// 					entry.target.classList.add('active')
	// 				}
	// 				observer.unobserve(entry.target)
	// 			}
	// 		})
	// 	}, options)
	// 	observer.observe(el)
	// }

	// Example usages:
	// scrollTrigger('.intro-text')

	// scrollTrigger('.scroll-reveal', {
	// 		rootMargin: '-200px',
	// })

	// scrollTrigger('.expand-section .image-wrapper', {
	// 	// rootMargin: '-200px',
	// 	cb: function (el) {
	// 		el.innerText = 'Loading...'
	// 		setTimeout(() => {
	// 			el.innerText = 'Task Complete!'
	// 		}, 1000)
	// 	},
	// })
})
